import Map from 'scripts/models/base/map';
import Image from 'scripts/models/api/image/image';

export default Map.extend({
    define: {
        code: {
            type: 'string',
            value: '' // required, min 3, max 3
        },
        name: {
            type: 'string',
            value: '' // required
        },
        flag: Image
    }
});